export const CREATE_MESSAGE = "CREATE_MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";

export const NOTIFICATION_CREATED = "NOTIFICATION_CREATED";
export const NOTIFICATION_CREATION_FAILED = "NOTIFICATION_CREATION_FAILED";

export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";